module.exports = __webpack_public_path__ + "static/img/wealth_level_53.881a0b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_53.png
// module id = j+sU
// module chunks = 0